import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="carrossel"]');

class Carrossel {
    constructor() {
        this.components = MODULE;
        this.breakpoint = window.matchMedia('(min-width: 1024px)');
        this.init();
    }

    init() {
        this.components.forEach((component) => {
            const swiperEl = component.querySelector('.swiper');
            if (!swiperEl) return;

            const state = { swiper: null };
            const handle = () => this.handle(component, swiperEl, state);

            this.breakpoint.addEventListener('change', handle);
            handle();
        });
    }

    handle(component, swiperEl, state) {
        if (state.swiper) {
            state.swiper.destroy(true, true);
            state.swiper = null;
        }

        const slides = swiperEl.querySelectorAll('.swiper-slide');
        const isDesktop = this.breakpoint.matches;

        const minSlides = isDesktop ? 3 : 2;
        const shouldInitSwiper = slides.length >= minSlides;

        const scope = isDesktop ? 'desktop' : 'mobile';
        const nav = component.querySelector(
            `[data-carrossel-nav="${scope}"]`
        );

        if (nav) {
            nav.style.display = shouldInitSwiper ? '' : 'none';
        }

        const wrapper = swiperEl.querySelector('.swiper-wrapper');

        wrapper?.classList.toggle(
            'is-static',
            !shouldInitSwiper
        );

        if (!shouldInitSwiper) {
            return;
        }

        state.swiper = new Swiper(swiperEl, {
            modules: [Navigation],
            slidesPerView: 'auto',
            spaceBetween: isDesktop ? 26 : 20,
            watchOverflow: true,
            navigation: {
                nextEl: nav?.querySelector('.swiper-button-next-circle'),
                prevEl: nav?.querySelector('.swiper-button-prev-circle'),
            },
        });
    }
}

(() => {
    if (MODULE.length) {
        new Carrossel();
    }
})();

export default Carrossel;
